import { render, staticRenderFns } from "./SimilarListingsKeywordFilter.vue?vue&type=template&id=56006c5d&"
import script from "./SimilarListingsKeywordFilter.vue?vue&type=script&lang=js&"
export * from "./SimilarListingsKeywordFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports